/* eslint-disable react/jsx-indent */
import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { getInitials } from 'modules/BPLS/applications/helper';
import CmsContext from 'context/CmsContext';
import SeniorCitizenInformation from './SeniorCitizenInformation';
import SeniorCitizenModal from '../modals/SeniorCitizenModal';
import DeactivateModal from '../modals/DeactivateModal';
import * as action from '../action';
import * as c from '../constant';

function SeniorCitizenContent({
  match,
  isLoading,
  permissions,

  showSeniorCitizen,
  clearSeniorCitizen,
  seniorCitizenInfo,

  // approveTransaction,
  // rejectTransaction,

  // transactionInfo,
  onApprove,
  onReject,
}) {
  const setModal = useContext(ModalContext);
  const selectedSeniorCitizen = match.params.id;

  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES')

  const updateData = () => {
    showSeniorCitizen(selectedSeniorCitizen);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedSeniorCitizen)) {
      updateData();
    }
    return () => {
      clearSeniorCitizen();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedSeniorCitizen)) {
      updateData();
    }
  }, [selectedSeniorCitizen]);

  const handleEditModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <SeniorCitizenModal
          actionType="EDIT"
          dataInfo={data.attributes}
          id={data.id}
        />
      ),
      title: 'Edit Citizen',
      modalSize: 'modal-lg',
    });
  };

  const handleDeactivateModal = (data) => (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <DeactivateModal data={data} id={selectedSeniorCitizen} />
      ),
      title: 'Deactivate Citizen',
      modalSize: 'modal-md'
    })
  };

  // format displayed name: Last, First, Middle
  const firstName = _.get(seniorCitizenInfo, 'attributes.first_name', " ") || ""
  const lastName = _.get(seniorCitizenInfo, 'attributes.last_name', "") || ""
  const middleName = _.get(seniorCitizenInfo, 'attributes.middle_name', " ") || ""
  const extName = _.get(seniorCitizenInfo, 'attributes.extension_name', " ") || ""

  const isActive = _.get(seniorCitizenInfo, 'attributes.is_active');

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        {/* <div className="w-100 d-flex p-4">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
            style={{ height: "32px" }}
          >
            <i className="fas fa-plus" /> &nbsp;&nbsp;
            Add Senior Citizen
          </button>
        </div> */}
        {/* profile */}
        <div className="px-4 d-flex justify-content-between align-items-center" style={{ fontSize: '24px' }}>
          <div className="p-0 d-flex flex-nowrap w-100">
            <div className="d-flex round-image justify-content-center">
              <h3 className="d-flex align-items-center initials mb-0">
                {_.get(seniorCitizenInfo, 'attributes.photo') !==
                '-/format/jpeg/' ? (
                  <img
                    alt="Client Profile"
                    src={_.get(seniorCitizenInfo, 'attributes.photo')}
                  />
                ) : (
                  getInitials(
                    `${_.get(seniorCitizenInfo, 'attributes.first_name')} ${_.get(
                      seniorCitizenInfo,
                      'attributes.middle_name'
                    )} ${_.get(seniorCitizenInfo, 'attributes.last_name')}`
                  )
                )}
              </h3>
            </div>
            <div className="d-flex flex-column ml-4 justify-content-center align-items-start">
              <h1 className="transaction-company m-0">
                {lastName && firstName ? `${lastName}, ` : `${lastName} `}
                {firstName && middleName ? `${firstName} ` : `${firstName} `}
                {middleName && extName ? `${middleName} ` : `${middleName} `}
                {extName}
              </h1>
              <div className='label-title mt-1'>{`${_.get(seniorCitizenInfo, 'attributes.mobile_number') || ''}`}</div>
            </div>
          </div>
          <div className='py-4'>
            {(isActive && Acl(permissions, ['SOCIAL AMELIORATION SENIOR DEACTIVATE']) ||
             !isActive && Acl(permissions, ['SOCIAL AMELIORATION SENIOR ACTIVATE'])) && (
              <button
                type="button"
                onClick={handleDeactivateModal(seniorCitizenInfo)}
                className={`btn ${
                  _.get(seniorCitizenInfo, 'attributes.is_active')
                  ? 'btn-danger'
                  : 'btn-primary cms-bg-color-primary cms-outline-primary '
                } font-weight-bold px-4 ml-2`}
                style={{ width: '164px', height: "32px" }}
              >
                {isActive
                  ? 'Deactivate'
                  : 'Activate'}
              </button>
            )}
          </div>
          {/* Edit Citizen */}
          <div className="py-4">
            <button
              type="button"
              onClick={handleEditModal(seniorCitizenInfo)}
              className="btn btn-success font-weight-bold px-4 ml-2"
              style={{ width: '164px', height: "32px" }}
            >
              <i className="fas fa-plus" /> &nbsp;&nbsp;
              Edit Information
            </button>
          </div>
        </div>
        <div className="mb-4">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  {/* Action buttons on top */}
                  <div className={`d-flex ml-auto justify-content-end mb-3 ${_.get(CMS_VARIABLES, 'LGU_NAME') === 'City of Borongan'}` && 'd-none'}>
                    {_.get(CMS_VARIABLES, 'LGU_NAME') !== 'City of Borongan' && (
                      <div className="d-flex flex-row justify-content-center align-items-center mr-4" style={{ height: '40px'}}>
                        <label className="alert" style={{ marginBottom: '0'}}>
                          <b>Amount: </b>
                        </label>
                        <div className="alert alert-info" style={{ marginBottom: '0'}}>
                          {_.get(seniorCitizenInfo, 'attributes.amount') || '- -'}
                        </div>
                      </div>
                    )}
                    {_.get(CMS_VARIABLES, 'LGU_NAME') !== 'City of Borongan' && (
                      <button
                        type="button"
                        onClick={onApprove(seniorCitizenInfo)}
                        className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mr-2"
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            Approve <i className="fas fa-check ml-1" />
                          </>
                        )}
                      </button>
                    )}
                    {_.get(CMS_VARIABLES, 'LGU_NAME') !== 'City of Borongan' && (
                      // reject
                      <button
                        type="button"
                        onClick={onReject(seniorCitizenInfo)}
                        className="gen-btn btn btn-danger font-weight-bold"
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>
                            Reject <i className="fas fa-times ml-1" />
                          </>
                        )}
                      </button>
                    )}
                  </div>
                  <hr />
                  <SeniorCitizenInformation
                    seniorCitizenInfo={seniorCitizenInfo}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

SeniorCitizenContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,

  // transactionInfo: PropTypes.instanceOf(Object).isRequired,

  clearSeniorCitizen: PropTypes.instanceOf(Function).isRequired,
  seniorCitizenInfo: PropTypes.instanceOf(Object).isRequired,
  showSeniorCitizen: PropTypes.instanceOf(Function).isRequired,

  // approveTransaction: PropTypes.instanceOf(Function).isRequired,
  // rejectTransaction: PropTypes.instanceOf(Function).isRequired,
  onApprove: PropTypes.instanceOf(Function).isRequired,
  onReject: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),

  // transactionInfo: _.get(api, `${c.SHOW_INCIDENT}.item`) || {},

  seniorCitizenInfo: _.get(api, `${c.SHOW_SENIOR_CITIZEN}.item`) || {},
  isLoading: api.loading.indexOf(c.SHOW_SENIOR_CITIZEN) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(SeniorCitizenContent);
